module.exports = __webpack_public_path__ + "img/icon-thumbs-down-fill.f86d9bbc.svg";